import { clsx } from 'clsx';
import { FC } from 'react';
import { Span } from 'atoms/Typography';
import { usePrice } from 'modules/formatter/hooks';
import styles from './styles.module.css';

export const PriceWithRegularFont: FC<{
  amount: number;
  currencyCode: string;
  className?: string;
}> = ({ amount, currencyCode, className }) => {
  const price = usePrice(amount, currencyCode);

  if (!price) {
    return null;
  }

  return (
    <Span className={clsx(styles.root, className)}>
      <Span className={styles.priceRegular}>{price.amount}</Span>{' '}
      <Span className={styles.currencyRegular}>{price.currency}</Span>
    </Span>
  );
};
